// ------------------------------------
// Constants
// ------------------------------------
export const SERVICES_POST_REQUEST = "SERVICES_POST_REQUEST";
export const SERVICES_POST_REQUEST_SUCCESS = "SERVICES_POST_REQUEST_SUCCESS";
export const SERVICES_POST_REQUEST_FAILURE = "SERVICES_POST_REQUEST_FAILURE";
export const SERVICES_POST_RESET = "SERVICES_POST_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(data, resolve, reject) {
  return {
    type: SERVICES_POST_REQUEST,
    data,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: SERVICES_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: SERVICES_POST_REQUEST_FAILURE,
    error,
  };
}

export function reset() {
  return {
    type: SERVICES_POST_RESET,
  };
}
